@if ((filters() | keyvalue)?.length || (exposedFilters() | keyvalue)?.length) {
  <mobi-view-filters
    class="block mobi-ui-margin-b-md"
    [viewId]="viewId()"
    [title]="title()"
    [autofocus]="autofocus()"
    [exposedFilters]="exposedFilters()"
    [scrollable]="scrollable()"
    [groupFilter]="groupFilter()"
    [hideFilters]="hideFilters()"
    [(filters)]="filters"
    (filterUpdate)="onFilterUpdate($event)"
    (selectionUpdate)="updateSelection($event.key, $event.value)"
  />
}
<mobi-view-results
  [results]="results()"
  [rows]="rows()"
  [loading]="loading()"
  [loadingMore]="loadingMore()"
  [hasPagination]="hasPagination"
  (loadNext)="loadNext()"
>
  <ng-content />
</mobi-view-results>
